import { useLocalSearchParams } from 'expo-router'

import { CommunityJoinSetupMailsScreen } from '@/src/features/community/ui/screens/CommunityJoinSetupMailsScreen'
import { filterSearchParams } from '@/src/general/utils/filterSearchParams'

const CommunityRouterPage = () => {
  const searchParams = useLocalSearchParams()
  const { idSlug } = filterSearchParams<TIdSlugParam>(searchParams)

  if (!idSlug) return null

  return <CommunityJoinSetupMailsScreen idSlug={idSlug} searchParams={searchParams} />
}

export default CommunityRouterPage
